export default function initSortDownloads() {

    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

}